import {callApi} from '@/api/api-core'

export const GetNotificationDetails = function(identifier){
    const request = {
        Identifier: identifier.toUpperCase()
    }
    return callApi('POST', 'api/notification/getdetails', request)
}